import * as Yup from 'yup';

export const DateSchema = Yup.object().shape({
  start: Yup.string().required('Este campo es requerido'),
  finish: Yup.string()
    .required('Este campo es requerido')
    .test(
      'max-90-days',
      'La diferencia entre ambos campos no puede ser mayor a 90 días',
      function (value) {
        const { start } = this.parent;
        if (start && value) {
          const diffInDays =
            (new Date(value).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24);
          return diffInDays <= 90;
        }
        return true;
      },
    ),
});

export const schema = Yup.object().shape({
  status: Yup.array(),
  note: Yup.string(),
  betweenDates: DateSchema,
});
